/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.notifications', [])
  /**
   * Service used to access all calls to the notifications rest service.
   */
  .factory('httpNotifications', function ($http) {
    /**
     * Returns the email notification setting for the organization.
     *
     * @returns {promise} A promise that when resolved will include an object.
     */
    var getEmailNotificationSettings = function () {
      return $http({
        method: 'GET',
        url: 'api/notifications/email'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Update the email notification setting for the organization.
     *
     * @returns {promise} A promise that when resolved will include an object.
     */
    var updateEmailNotificationSettings = function (frequency, address) {
      return $http({
        method: 'POST',
        url: 'api/notifications/email',
        data: {
          emailNotificationFrequency: frequency,
          emailAddress: address
        }
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Returns the chatter setting for the organization.
     *
     * @returns {promise} A promise that when resolved will include an object.
     */
    var getChatterSettings = function () {
      return $http({
        method: 'GET',
        url: 'api/notifications/chatter'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Updates the chatter setting for the organization.
     *
     * @returns {promise} A promise that when resolved will include an object.
     */
    var updateChatterSettings = function (notificationEnabled, notificationId, isGroup, humanReadableName) {
      return $http({
        method: 'POST',
        url: 'api/notifications/chatter',
        data: {
          chatterNotificationEnabled: notificationEnabled,
          chatterNotificationId: notificationId,
          isChatterNotificationIdAGroup: isGroup,
          chatterNotificationName: humanReadableName
        }
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      getEmailNotificationSettings: getEmailNotificationSettings,
      updateEmailNotificationSettings: updateEmailNotificationSettings,
      getChatterSettings: getChatterSettings,
      updateChatterSettings: updateChatterSettings
    };
  });
